import { useCallback, useEffect, useRef, useState } from 'react';

export function useFlash(timeout = 5000) {
  const timeoutRef = useRef<number | null>(null);
  const [activeFlash, setActiveFlash] = useState<{ type: 'success' | 'error'; message: string } | null>(null);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setActiveFlash(null);
    }, timeout);

    // we don't want to re-run if timeout changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFlash]);

  const clearFlash = useCallback(() => {
    setActiveFlash(null);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return [activeFlash, setActiveFlash, clearFlash] as const;
}
